import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SettingsService } from '@ipreo/northstar';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import {
  getSettingsFormControls,
  INITIAL_USER_SETTINGS,
} from '../helpers/settings-form.helper';
import {
  BenchmarkCurve,
  FlexColumn,
  MuniUserSettingsModel,
} from './../models/muni-user-settings.model';

@Component({
  selector: 'polaris-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSettingsComponent implements OnInit, OnDestroy {
  public userSettings: MuniUserSettingsModel;
  public benchmarkCurveModel = BenchmarkCurve;
  public flexColumnModel = FlexColumn;
  public hasMmdDataPermission = true;
  public userSettingsForm: FormGroup;
  public destroy$ = new Subject<void>();

  constructor(private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.initializeUserSettingsForm();
    this.handleFormChanges();
    this.subscribeToUserSettings();
  }

  private initializeUserSettingsForm(): void {
    this.userSettings = INITIAL_USER_SETTINGS;
    this.userSettingsForm = new FormGroup(
      getSettingsFormControls(this.userSettings)
    );
  }

  private handleFormChanges(): void {
    this.userSettingsForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((changes) =>
        this.settingsService.set('muni.user-preferences', changes)
      );
  }

  private subscribeToUserSettings(): void {
    this.settingsService
      .get('muni.user-preferences')
      .pipe(
        filter((settings) => settings.loaded),
        takeUntil(this.destroy$)
      )
      .subscribe((settings) => {
        this.userSettings = (settings.setting as unknown) as MuniUserSettingsModel;
        this.userSettingsForm.patchValue(this.userSettings, {
          emitEvent: false,
        });
      });
  }

  public isMmdAlertShown(): boolean {
    return false;
  }

  public sortByPermission = (): number => {
    return 0;
  };

  public disableSorting = (): number => {
    return 0;
  };

  public closeMmdAlert(): void {
    return;
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
